import { ProcessAPI } from 'lecom-api';
import { getParamUrl } from '../../utils/query_string_parser';

const ParamHandler = {

	getLanguage(){
		if (ProcessAPI.currentProcess())
			return ProcessAPI.currentProcess().language();
		let language = getParamUrl("language");
		if (language) return language;
		return null;
	}

}

export default ParamHandler;
